<template>
  <div class="reportWrapper">
    <div class="report-component" id="tr-exec-sum-html">
      <p class="announcement-date">BY: {{ cwaData.Author }}</p>
      <div
        class="margin-top--quarter margin-bottom--quarter background-blue inner-padding--half font-white intro rounded-corners-10"
      >
        {{ cwaData.PageTitle }}
      </div>

      <div
        class="tr-exec-sum-html__section"
        v-for="section in sections"
        :key="section.Order"
      >
        <div v-if="section.Image" class="tr-exec-sum-html__image">
          <img :src="section.Image" alt="Executive Summary Section Image" />
        </div>
        <div v-else class="tr-exec-sum-html__content">
          <h4 class="tr-exec-sum-html__header">{{ section.Header }}</h4>
          <div class="tr-exec-sum-html__text" v-html="section.Section"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment';
  export default {
    name: 'ExecutiveSummaryTemplate',
    props: {
      cwaData: {
        type: Object,
        required: true,
      },
    },
    data: () => ({}),
    computed: {
      sections() {
        let sections = this.cwaData.Sections;
        return sections.sort((a, b) => a.Order - b.Order);
      },
    },
    methods: {
      momentFormat(date, format) {
        return moment(date).format(format);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .intro {
    font-style: italic;
  }
  .tr-exec-sum-html {
    &__section {
      margin: 4rem 0;
    }
    &__image {
      max-width: 1000px;
      margin: 0 auto;
      text-align: center;
    }
    &__header {
      margin-bottom: 0.5rem;
    }
    &__text {
      * {
        font-size: 17px !important;
        color: var(--itr-charcoal) !important;
        background-color: transparent !important;
        font-family: 'Open Sans', sans-serif !important;
      }
    }
  }
</style>
